import React, { useState, useEffect } from "react";
import {
    Row,
    Col,
    Input,
    Label,
    Button,
    Spinner,
} from "reactstrap";
import axiosConfig from "../../AxiosConfig"
export default function WastageReport() {
    const [search, setSearch] = useState("");
    const [report, setReport] = useState([]);
    const [loading, setLoading] = useState(false);

    const getCurrentFY = () => {
        const today = new Date();
        const year = today.getMonth() >= 3
            ? today.getFullYear()
            : today.getFullYear() - 1;

        return `${year}-${year + 1}`;
    };

    const getFinancialYearOptions = () => {
        const today = new Date();
        const current =
            today.getMonth() >= 3
                ? today.getFullYear()
                : today.getFullYear() - 1;

        const arr = [];

        for (let i = -4; i <= 4; i++) {
            arr.push(`${current + i}-${current + i + 1}`);
        }

        return arr;
    };
    const [financialYear, setFinancialYear] = useState(getCurrentFY());

    const getReport = async () => {
        try {
            setLoading(true);

            const user = JSON.parse(localStorage.getItem("userData"));

            const res = await axiosConfig.get(
                `/production-steps/wastage-report/${user.database}/${financialYear}`
            );

            const sortedData = (res?.data?.data || []).sort(
                (a, b) => new Date(a.date) - new Date(b.date)
            );

            setReport(sortedData);
        } catch (err) {
            console.log(err);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        getReport();
    }, [financialYear]);

    const filteredData = report.filter((item) => {
        return (
            item.productSection
                ?.toLowerCase()
                .includes(search.toLowerCase()) ||
            item.date?.includes(search)
        );
    });

    const totalSQInch = filteredData.reduce((total, item) => {
        return (
            total +
            Number(
                item?.units?.find(
                    (u) => u.unit?.toLowerCase() === "sqinch"
                )?.qty || 0
            )
        );
    }, 0);

    const totalWeight = filteredData.reduce((total, item) => {
        return (
            total +
            Number(
                item?.units?.find(
                    (u) => u.unit?.toLowerCase() === "kg"
                )?.qty || 0
            )
        );
    }, 0);
    const chunkArray = (array, size) => {
        const result = [];

        for (let i = 0; i < array.length; i += size) {
            result.push(array.slice(i, i + size));
        }

        return result;
    };

    // 10 record per block
    const rows = chunkArray(filteredData, 10);

    const formatDate = (date) => {
        if (!date) return "";

        return new Date(date).toLocaleDateString("en-GB");
    };

    return (
        <div className="container-fluid mt-3">
            <div className="card">
                <div className="card-header d-flex justify-content-between align-items-center">

                    <h4 className="mb-0">Wastage Report</h4>

                    <div className="d-flex align-items-end" style={{ gap: "12px" }}>

                        <div>
                            <Label className="mb-1">Total SQ Inch</Label>

                            <Input
                                value={Number(totalSQInch || 0).toFixed(2)}
                                readOnly
                                style={{ width: "120px" }}
                            />
                        </div>

                        <div>
                            <Label className="mb-1">Total Weight</Label>

                            <Input
                                value={Number(totalWeight || 0).toFixed(2)}
                                readOnly
                                style={{ width: "120px" }}
                            />
                        </div>

                        <div style={{ width: "180px" }}>
                            <Label className="mb-1">Financial Year</Label>

                            <Input
                                type="select"
                                value={financialYear}
                                onChange={(e) => setFinancialYear(e.target.value)}
                            >
                                {getFinancialYearOptions().map((fy) => (
                                    <option key={fy} value={fy}>
                                        {fy}
                                    </option>
                                ))}
                            </Input>
                        </div>

                        <div style={{ width: "220px" }}>
                            <Label className="mb-1">Search</Label>

                            <Input
                                placeholder="Search..."
                                value={search}
                                onChange={(e) => setSearch(e.target.value)}
                            />
                        </div>

                        <Button
                            color="primary"
                            style={{ height: "38px" }}
                            onClick={getReport}
                        >
                            Search
                        </Button>

                    </div>

                </div>
                <div className="card-body table-responsive">
                    <table className="table table-bordered text-center">
                        <thead>
  <tr>
    {rows.map((_, index) => {
      const bgColors = [
        "#dbeafe", // Blue
        "#dcfce7", // Green
        "#fef3c7", // Yellow
        "#fce7f3", // Pink
        "#ede9fe", // Purple
        "#fee2e2", // Red
      ];

      const bgColor = bgColors[index % bgColors.length];

      return (
        <React.Fragment key={index}>
          <th style={{ backgroundColor: bgColor }}>Date</th>
          <th style={{ backgroundColor: bgColor }}>Product Section</th>
          <th style={{ backgroundColor: bgColor }}>SQ Inch</th>
          <th style={{ backgroundColor: bgColor }}>Weight</th>
        </React.Fragment>
      );
    })}
  </tr>
</thead>

                        <tbody>
                            {Array.from({
                                length: Math.max(...rows.map(r => r.length))
                            }).map((_, rowIndex) => (
                                <tr key={rowIndex}>
                                    {rows.map((group, groupIndex) => {
                                        const item = group[rowIndex];

                                        return (
                                            <React.Fragment key={groupIndex}>
                                                <td>{formatDate(item?.date)}</td>

                                                <td>{item?.productSection || "-"}</td>

                                                <td>
                                                    {Number(
                                                        item?.units?.find(
                                                            u => u.unit?.toLowerCase() === "sqinch"
                                                        )?.qty || 0
                                                    ).toFixed(2)}
                                                </td>

                                                <td>
                                                    {Number(
                                                        item?.units?.find(
                                                            u => u.unit?.toLowerCase() === "kg"
                                                        )?.qty || 0
                                                    ).toFixed(2)}
                                                </td>
                                            </React.Fragment>
                                        );
                                    })}
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
}